import React, { useState, useEffect, useMemo } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Box, Typography, TextField, InputAdornment,
    Button, Stack, ButtonBase, IconButton
} from '@mui/material';
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import {useGoogleAutocompleteUniversal} from "../../Helpers/GoogleAutocomplete";




const ReceiptDialogEditLocation = ({ isOpen, onClose, receipt, onSave }) => {
    const { PA_GlobalObject } = usePA_GlobalStore();

    // 1. Get trip data from Zustand
    const eventLodging = PA_GlobalObject?.Planning?.lodging || [];
    const eventMeals = PA_GlobalObject?.Planning?.meals || [];
    const eventActivities = PA_GlobalObject?.Planning?.activities || [];

    // 2. Structured Location State
    const [location, setLocation] = useState({
        name: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        formatted_address: '',
        google_place_id: '',
        latitude: null,
        longitude: null
    });


    const parseV2Address = (place) => {
        let _address_line = "", _address_city = "", _address_state = "", _address_zip = "", _address_country = "";
        const components = place.addressComponents || [];
        const _country_comp = components.find(c => c.types.includes("country"));
        const _country_code = _country_comp?.shortText || "";

        components.forEach((component) => {
            const types = component.types;
            const val = component.longText;
            if (types.includes("street_number")) _address_line = val;
            else if (types.includes("route")) _address_line = _address_line ? `${_address_line} ${val}` : val;
            else if (types.includes("locality")) _address_city = val;
            else if (types.includes("administrative_area_level_1")) _address_state = (_country_code === "US") ? component.shortText : val;
            else if (types.includes("postal_code")) _address_zip = val;
            else if (types.includes("country")) _address_country = component.shortText;
        });

        if (!_address_line && place.formattedAddress) {
            _address_line = place.formattedAddress.split(',')[0].trim();
        }
        return { _address_line, _address_city, _address_state, _address_zip, _address_country };
    };
    const handleUniversalSelect = (place, isBusiness) => {
        console.log("the selected Place 111: ", place.toJSON());

        const parsedAddr = parseV2Address(place);
        console.log("the parsedAddr 111: ", parsedAddr);
        // Shared Location Object Mapper
        const mapToPALocation = (place, parsed) => {
            const loc = {};
            loc.google_place_id = place.id;
            loc.latitude = typeof place.location?.lat === 'function' ? place.location.lat() : place.location?.lat;
            loc.longitude = typeof place.location?.lng === 'function' ? place.location.lng() : place.location?.lng;
            loc.name = place.displayName?.text || place.displayName;
            loc.formatted_address = place.formattedAddress;
            loc.address = parsed._address_line;
            loc.city = parsed._address_city;
            loc.state = parsed._address_state;
            loc.zip = parsed._address_zip;
            loc.country = parsed._address_country;

            console.log("the selected address : ", loc);
            return loc;
        };

        setLocation(mapToPALocation(place, parsedAddr));
    };
    const {
        containerRef: editReceiptLocationRef,
        initAutocomplete: initUniversal,
        autocompleteInstance
    } = useGoogleAutocompleteUniversal(handleUniversalSelect);

    useEffect(() => {
        // Every time the tab changes or the ref becomes available,
        // try to (re)initialize/append the autocomplete
        if (editReceiptLocationRef.current) {
            initUniversal();
        }
    }, [editReceiptLocationRef.current]);




    const [selectedTripId, setSelectedTripId] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    // 3. Categorize trip items for the UI
    const categorizedTripItems = useMemo(() => {
        return [
            { label: 'Lodging', items: eventLodging, icon: 'icon-bed' },
            { label: 'Meals', items: eventMeals, icon: 'icon-fork-knife2' },
            { label: 'Activities', items: eventActivities, icon: 'icon-list-heart' }
        ].filter(group => group.items.length > 0);
    }, [eventLodging, eventMeals, eventActivities]);

    // 4. Initialize fields and matching logic
    useEffect(() => {
        if (isOpen && receipt) {
            const currentLoc = receipt.location || {};

            // Sync state with existing receipt data
            setLocation({
                name: currentLoc.name || '',
                address: currentLoc.address || '',
                city: currentLoc.city || '',
                state: currentLoc.state || '',
                zip: currentLoc.zip || '',
                country: currentLoc.country || '',
                formatted_address: currentLoc.formatted_address || '',
                google_place_id: currentLoc.google_place_id || '',
                latitude: currentLoc.latitude || null,
                longitude: currentLoc.longitude || null
            });

            // Check if current address matches a trip item for the checkmark
            const allItems = [...eventLodging, ...eventMeals, ...eventActivities];
            const match = allItems.find(item => item.address === currentLoc.address);
            if (match) {
                setSelectedTripId(match.id);
            } else {
                setSelectedTripId(null);
            }
        }
    }, [isOpen, receipt, eventLodging, eventMeals, eventActivities]);

    const handleSelectTripItem = (item) => {
        setSelectedTripId(item.id);
        setLocation({
            name: item.location?.name || item.title || '',
            address: item.location?.address || '',
            city: item.location?.city || '',
            state: item.location?.state || '',
            zip: item.location?.zip || '',
            country: item.location?.country || 'US',
            formatted_address: item.location?.formatted_address || item.location?.address || '',
            google_place_id: item.location?.google_place_id || '',
            latitude: item.location?.latitude || null,
            longitude: item.location?.longitude || null
        });
    };

    const updateLocationField = (field, value) => {
        setLocation(prev => ({ ...prev, [field]: value }));
        setSelectedTripId(null); // Manual edit breaks the trip-item link
    };

    const handleSave = () => {
        onSave(receipt.id, { location });
        onClose();
    };

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { borderRadius: '24px', overflow: 'hidden' } }}
        >
            {/* Header */}
            <DialogTitle sx={{
                background: 'linear-gradient(135deg, #151269 0%, #352fcc 100%)',
                color: 'white', fontWeight: 800, display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 2
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <i className="icon-map-marker" style={{ fontSize: '20px' }} />
                    <Typography variant="h6" sx={{ fontWeight: 800 }}>Update Location</Typography>
                </Box>
                <IconButton onClick={onClose} sx={{ color: 'white', opacity: 0.8 }}>
                    <i className="icon-cross" />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ p: 3, bgcolor: '#fcfcfc' }}>
                <Stack spacing={3} sx={{ mt: 1 }}>

                    {/* OPTION 1: Search */}
                    <Box>
                        <Typography variant="overline" sx={{ fontWeight: 800, color: '#151269', mb: 0.5, display: 'block' }}>Search for Address</Typography>
                        <TextField
                            ref={editReceiptLocationRef}
                            fullWidth
                            placeholder="Find place on Google Maps..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            InputProps={{
                                startAdornment: <InputAdornment position="start"><i className="icon-search" style={{ color: '#151269' }} /></InputAdornment>,
                                sx: { borderRadius: '12px', bgcolor: 'white' }
                            }}
                        />
                    </Box>

                    {/* OPTION 2: Categorized Trip Suggestions */}
                    <Box>
                        <Typography variant="overline" sx={{ fontWeight: 800, color: '#151269', mb: 0.5, display: 'block' }}>Suggested Trip Items</Typography>
                        <Box sx={{
                            maxHeight: '220px',
                            overflowY: 'auto',
                            borderRadius: '16px',
                            border: '1px solid #eee',
                            bgcolor: 'white'
                        }}>
                            {categorizedTripItems.length > 0 ? categorizedTripItems.map((group) => (
                                <Box key={group.label}>
                                    <Box sx={{ bgcolor: '#f1f3f9', px: 2, py: 0.5 }}>
                                        <Typography variant="caption" sx={{ fontWeight: 900, color: '#151269', textTransform: 'uppercase' }}>
                                            {group.label}
                                        </Typography>
                                    </Box>
                                    {group.items.map((item) => (
                                        <ButtonBase
                                            key={item.id}
                                            onClick={() => handleSelectTripItem(item)}
                                            sx={{
                                                width: '100%', display: 'flex', justifyContent: 'space-between', p: 1.5,
                                                borderBottom: '1px solid #f0f0f0',
                                                bgcolor: selectedTripId === item.id ? 'rgba(21, 18, 105, 0.05)' : 'transparent',
                                                '&:hover': { bgcolor: '#f8f9fa' }
                                            }}
                                        >
                                            <Box sx={{ textAlign: 'left', display: 'flex', alignItems: 'center', gap: 2 }}>
                                                <Box sx={{
                                                    width: 32, height: 32, borderRadius: '8px',
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                    bgcolor: selectedTripId === item.id ? '#151269' : '#f0f0f0',
                                                    color: selectedTripId === item.id ? 'white' : '#151269'
                                                }}>
                                                    <i className={group.icon} />
                                                </Box>
                                                <Box>
                                                    <Typography variant="body2" sx={{ fontWeight: 700 }}>{item.name || item.title}</Typography>
                                                    <Typography variant="caption" color="textSecondary" sx={{ display: 'block' }}>
                                                        {item.address}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            {selectedTripId === item.id && <i className="icon-check" style={{ color: '#151269', fontWeight: 'bold' }} />}
                                        </ButtonBase>
                                    ))}
                                </Box>
                            )) : (
                                <Typography variant="caption" sx={{ p: 3, display: 'block', textAlign: 'center', color: '#aaa', fontStyle: 'italic' }}>
                                    No trip itinerary items found.
                                </Typography>
                            )}
                        </Box>
                    </Box>

                    {/* OPTION 3: Detailed Manual Entry */}
                    <Box sx={{ p: 2.5, borderRadius: '20px', border: '2px solid #15126910', bgcolor: '#f8f9fa' }}>
                        <Typography variant="caption" sx={{ fontWeight: 900, color: '#151269', mb: 2, display: 'block', textAlign: 'center', opacity: 0.6 }}>
                            — MANUAL ADDRESS DETAILS —
                        </Typography>
                        <Stack spacing={1.5}>
                            <TextField
                                fullWidth label="Business Name" size="small"
                                value={location.name} onChange={(e) => updateLocationField('name', e.target.value)}
                                InputProps={{ sx: { borderRadius: '8px', bgcolor: 'white', fontWeight: 600 } }}
                            />
                            <TextField
                                fullWidth label="Address" size="small"
                                value={location.address} onChange={(e) => updateLocationField('address', e.target.value)}
                                InputProps={{ sx: { borderRadius: '8px', bgcolor: 'white' } }}
                            />
                            <TextField
                                fullWidth label="City" size="small"
                                value={location.city} onChange={(e) => updateLocationField('city', e.target.value)}
                                InputProps={{ sx: { borderRadius: '8px', bgcolor: 'white' } }}
                            />
                            <TextField
                                fullWidth label="State / Province" size="small"
                                value={location.state} onChange={(e) => updateLocationField('state', e.target.value)}
                                InputProps={{ sx: { borderRadius: '8px', bgcolor: 'white' } }}
                            />
                            <TextField
                                fullWidth label="ZIP / Postal Code" size="small"
                                value={location.zip} onChange={(e) => updateLocationField('zip', e.target.value)}
                                InputProps={{ sx: { borderRadius: '8px', bgcolor: 'white' } }}
                            />
                            <TextField
                                fullWidth label="Country" size="small"
                                value={location.country} onChange={(e) => updateLocationField('country', e.target.value)}
                                InputProps={{ sx: { borderRadius: '8px', bgcolor: 'white' } }}
                            />
                        </Stack>
                    </Box>
                </Stack>
            </DialogContent>

            <DialogActions sx={{ p: 3, bgcolor: '#f8f9fa', borderTop: '1px solid #eee' }}>
                <Button onClick={onClose} sx={{ color: '#666', fontWeight: 700 }}>Cancel</Button>
                <Button
                    variant="contained"
                    onClick={handleSave}
                    sx={{
                        bgcolor: '#151269',
                        borderRadius: '12px',
                        px: 4,
                        fontWeight: 800,
                        '&:hover': { bgcolor: '#251eb2' }
                    }}
                >
                    Update Location
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ReceiptDialogEditLocation;